import { requestOri } from "./apiRequests";
import useApiResult from "./useApiResult";

const useRequestOri = async (newOri) => {
    const request = requestOri(newOri);
    const response = await useApiResult(request);
    if (!response || response[1]) {
        return response;
    }
    if (response[0]) {
        const { Data } = response[0];
        return Data;
    }
    
    return response;

}
export default useRequestOri;